import { render, staticRenderFns } from "./ClipboardBtn.vue?vue&type=template&id=32360354&"
import script from "./ClipboardBtn.vue?vue&type=script&lang=js&"
export * from "./ClipboardBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports